/**
 * Builds a URL-safe slug from a static section title.
 *
 * Used for test ids and as the base of heading ids so navigation links stay
 * stable without hardcoding identifiers in JSON.
 *
 * @param title - Visible section heading
 * @returns Lowercase hyphenated slug
 */
function toStaticPageSlug(title: string): string {
  return title
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

/**
 * Builds the heading id that contents links and section headings share.
 *
 * Pair {@link StaticPageNavigation} links with {@link StaticPageSection}
 * headings by passing the same title into both.
 *
 * @param title - Visible section heading
 * @returns `{slug}-heading`
 */
function toStaticPageSectionId(title: string): string {
  return `${toStaticPageSlug(title)}-heading`;
}

export { toStaticPageSectionId, toStaticPageSlug };
